// extracted by mini-css-extract-plugin
export default {"chart":"ToothChart_chart__x9+la","row":"ToothChart_row__9Y9G1","spacer":"ToothChart_spacer__Ra+Ne","tooth":"ToothChart_tooth__7OzTN","toothActive":"ToothChart_toothActive__6kY7-"};